export default __webpack_public_path__ + "static/media/GMBG.680a20b8.png";